import {Component, OnInit, Input, OnChanges, forwardRef, Injector} from '@angular/core';
import { VnaServiceService } from '../../services/vna-service.service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from '@angular/forms';

const SELECT_VNA_SERVICE_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectVnaServiceComponent)
};

@Component({
    selector: 'app-select-vna-service',
    template: `
        <select id="{{ id }}" name="{{ id }}" class="form-control" [(ngModel)]="selectedValue" [class.is-invalid]="!control.control.valid && submitted" >
            <option [value]="getValue(s)" *ngFor="let s of vnaServices">{{s.name}}</option>
        </select>
      `,
    styleUrls: ['./select-vna-service.component.scss'],
    providers: [SELECT_VNA_SERVICE_VALUE_ACCESSOR]
})
export class SelectVnaServiceComponent implements OnInit, ControlValueAccessor {

    @Input() type: string;
    @Input() id: string;
    @Input() valueType: string;
    @Input() submitted: boolean = false;

    _selectedValue: any;
    private onTouched: Function;

    /**
     *
     */
    control: NgControl;

    /**
     *
     */
    vnaServices: Array<Object>;

    constructor(private vna: VnaServiceService, private inj: Injector) {
        this.vnaServices = [];
    }

    ngOnInit() {
        this.vna.findServicesByType(this.type).subscribe(
            result => {
                this.vnaServices = result;
            }
        );
        this.control = this.inj.get(NgControl);
    }

    get selectedValue(): any { return this._selectedValue; };

    set selectedValue(v: any) {
        //if (v !== this._selectedValue) {
            this._selectedValue = v;
            this.propagateChange(this._selectedValue);
        //}
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        this._selectedValue = value;
    }

    getValue(s: Object): any {
        return (this.valueType === 'alias') ? s['alias'] : s['pk'];
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_services/components/select-vna-service/select-vna-service.component.ts